function filterByPaxCount(expReq, minCount, maxCount) {
    const totalCount = expReq.adultCount + expReq.kidsCount + expReq.package.kids + expReq.package.adults;
    return totalCount >= minCount && totalCount <= maxCount;
}

export default function filterDinnersByPax(expRequests, paxFilter) {
    let filterData = [];

    if (paxFilter === "All" || paxFilter == null) {
        filterData = expRequests;
    } else if (paxFilter === "8>") {
        filterData = expRequests.filter(expReq =>
            filterByPaxCount(expReq, 8, Infinity) ||
            (expReq?.package?.adults + expReq?.package?.kids + expReq.package.kids + expReq.package.adults) >= 8
        );
    } else if (Number.isInteger(paxFilter) && paxFilter >= 2 && paxFilter <= 8) {
        filterData = expRequests.filter(expReq =>
            filterByPaxCount(expReq, paxFilter-1, paxFilter)
        );
    }

    return filterData;
}
